import React from "react";
import { Box, Button, Typography } from "@material-ui/core";

import { AuthPages } from "./";
import PasswordField from "../../components/inputs/PasswordField";

import { Form, Navigation, useFormik, useLocation, yup } from "../../lib";
import { authActions, useAction } from "../../state";

import { useStyles } from "./Auth.styles";

const validationSchema = yup.object({
  password1: yup
    .string()
    .min(8, "Password should be of minimum 8 characters length")
    .required("Password is required"),
  password2: yup
    .string()
    .min(8, "Password should be of minimum 8 characters length")
    .required("Password is required"),
});

const ConfirmAccountPage = () => {
  const classes = useStyles();
  const confirmAccount = useAction(authActions.confirmAccount);
  const location = useLocation();

  const form = useFormik({
    initialValues: {
      password1: "",
      password2: "",
    },
    validationSchema,
    async onSubmit(values) {
      // TODO: Validate passwords. See mailpake/prime client-app ResetPasswordPage.jsx
      await confirmAccount({
        newPassword: values.password1,
        email: location.query.email,
        token: location.query.token,
      });
      Navigation.replace(AuthPages.login);
    },
  });

  return (
    <Box className={classes.authCard}>
      <Typography variant="h2" component="h1" className={classes.titleText}>
        Confirm Account
      </Typography>
      <Typography variant="subtitle1" className={classes.subtitleText}>
        Enter your new password here.
      </Typography>
      <Form form={form} className={classes.form}>
        <PasswordField
          name="password1"
          label="New password"
          value={form.values.password1}
          handleChange={form.handleChange}
          touched={form.touched.password1}
          error={form.errors.password1}
        />
        <PasswordField
          name="password2"
          label="Re-enter new password"
          value={form.values.password2}
          handleChange={form.handleChange}
          touched={form.touched.password2}
          error={form.errors.password2}
        />

        <div className={classes.buttonBox}>
          <Button color="primary" variant="contained" type="submit" disabled={form.isSubmitting}>
            Signup
          </Button>
        </div>
      </Form>
    </Box>
  );
};

export default React.memo(ConfirmAccountPage);
